//////// GHG 3.10 EA
const threeTenSchema = {
  title: "3.10 Processing of Solid Products",
  addAPI: "cat5_1AddEmissionActivityAPI",
  cat: "cat5_1",
  EATitle: "Emission Activity",
  fields: [
    {
      key: "itemName",
      level: 1,
      type: "input",
      label: "Name / Number",
      resetOnChange: false,
      required: true,
    },
    //////// Activity Type
    {
      key: "ghgActivityNameId",
      level: 1,
      type: "select",
      label: "Activity Type",
      optionsAPI: "ghg5_1EADropdownAPI",
      required: true,
    },
  ],
};
export default threeTenSchema;
